import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.41 12h19.8", stroke: "#fff", strokeWidth: 2 }));
export default SvgMinus;
